const mixins = {
  data() {
    return {
      permissionList: [], // 权限数据
      globalPaymentStatus: '0', // 0正在支付中 1支付成功
      isOpenTime: null,
      isScannerInput: false,   // 是否正在扫码枪输入
      isScannerEnter: false,   // 标识当前回车是否来自扫码枪
    }
  },
  directives: {
    // 标记边框色
    border_color: {
      inserted: function (el) {
        el.style.border = '2px solid rgb(64, 158, 255)'
      }
    }
  },
  filters: {
    // 过滤卡图片
    filterCardPic(cardTypeCode, type) {
      let cardImage = ''
      if (type === 'img') {
        cardTypeCode === 2 && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_member_czk.png');
        (cardTypeCode === 3 || cardTypeCode === 0) && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_member_ck.png')
        cardTypeCode === 1 && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_member_zkk.png')
      } else if (type === 'bg') {
        cardTypeCode === 2 && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_czk_bg.png');
        (cardTypeCode === 3 || cardTypeCode === 0) && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_ck_bg.png')
        cardTypeCode === 1 && (cardImage = 'https://meiqiling.oss-cn-shenzhen.aliyuncs.com/static/img/mql_zkk_bg.png')
      }
      return cardImage
    }
  },
  beforeDestroy() {
    this.turnOffTimer()
  },
  computed: {
    // 订单管理权限
    orderManagementAuthority() {
      return this.permissionList.some(item => item.resourceCode === 'ORDER_MANAGE')
    },
    // 员工业绩权限
    employeePerformanceAuthority() {
      return this.permissionList.some(item => item.resourceCode === 'DATA_CENTER')
    },
    // 门店业绩权限
    storePerformanceAuthority() {
      return this.permissionList.some(item => item.resourceCode === 'MONEY_MANAGE')
    },
    // 会员中心管理权限
    memberCenterManagementRights() {
      return this.permissionList.some(item => item.resourceCode === 'MEMBER_SHIP')
    },
    // 产品下单是否可查看库存数
    productInventoryNumberPermission() {
      return this.permissionList.some(item => item.resourceCode === 'APP26')
    },
    // 开卡允许修改原价
    openTheCardToModifyTheOriginalPrice() {
      return this.permissionList.some(item => item.resourceCode === 'ORDER_MANAGE06')
    },
    // 开卡允许修改赠送金额
    amountGiftCanBemodifiedByopeningCard() {
      return this.permissionList.some(item => item.resourceCode === 'ORDER_MANAGE05')
    },
    // 是否开通拉卡拉支付
    whetherToEnableLacaraPayment() {
      return window.localStorage.getItem('lakal');
    },
    // 是否禁用修改业绩
    whetherToDisablePerformanceModification() {
      return this.permissionList.some(item => item.resourceCode === 'ORDER_MANAGE08')
    },
    whetherToEnableThecDInSetting() {
      return this.permissionList.some(item => item.resourceCode === 'STORE_MANAGE07')
    }
  },
  watch: { // 当弹窗被激活时 关闭搜索框
    // 监听抽屉激活（挂单、开卡、轮牌、结账）
    drawer(newVal) {
      if (newVal && this.searchInputBoxShow) {
        typeof this.closeSearch === 'function'
          ? this.closeSearch()
          : (this.searchInputBoxShow = false, this.queryItem = '');
      }
    },
    // 监听打卡弹窗激活
    punchTheWindow(newVal) {
      if (newVal && this.searchInputBoxShow) {
        typeof this.closeSearch === 'function'
          ? this.closeSearch()
          : (this.searchInputBoxShow = false, this.queryItem = '');
      }
    }
  },
  methods: {
    // 分析当前数据是商品还是产品
    analyticalDataCommodity(item) {
      // 0 项目 1 产品
      return item.packageName ? '0' : '1'
    },
    // 更新权限数据
    updatePermissionData() {
      // 获取门店权限信息
      this.API.paperless.getStorePermissionInformation(window.localStorage.getItem('tenantId')).then(res => {
        this.permissionList = res.data
      })
    },
    // 精准度丢失合计
    accuracyCheck(arg1 = 0, arg2 = 0, type) {
      let number1 = parseFloat((arg1 * 1).toPrecision(5))
      let number2 = parseFloat((arg2 * 1).toPrecision(5))
      if (type === '-') return parseFloat((number1 - number2).toPrecision(5))
      else return parseFloat((number1 + number2).toPrecision(5))
    },
    // 深拷贝
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    // 开启项目查询
    openProjectQuery(isOpen, key) {
      // 扫码枪输入则不弹出搜索框
      if (this.isScannerInput) return

      // 有抽屉或弹窗被激活 不弹出搜索框
      if (this.drawer || this.inputEquipmentShow || this.theHandNumberPopsUp || this.punchTheWindow || this.modifyData) {
        return
      }

      // 若员工列表正在显示，先关闭它
      if (isOpen && this.$refs.employeeRef && this.$refs.employeeRef.style.transform === 'translateX(0px)') {
        this.$refs.employeeRef.style.transform = 'translateX(520px)';
        this.employeeNumber = '';
        this.employeeList = this.deepCopy(this.currentEmployeeList);
      }

      console.log('是否关闭', isOpen)
      if (this.queryItem === '禁止' || this.cardRemarks || this.modifyData || this.inputEquipmentShow) return
      if (isOpen) {
        setTimeout(() => {
          // 如果为扫码枪退出执行
          if (this.isOpenTime) return true
          this.$nextTick(() => {
            this.searchInputBoxShow = true
            if (key && !this.queryItem) {
              this.queryItem = key
              this.filterItemData() // 赋值的操作不会触发keyup查询 需要手动调用一下
            }
            this.$refs.itemQueryRef.focus()
          })
        }, 200)
      } else {
        this.$nextTick(() => {
          this.searchInputBoxShow = false
          this.queryItem = ''
          // this.projectTypeList[0].dictName === '全部' && this.projectTypeList.splice(0, 1)
          // this.projectType = 0
          // this.switchItems(this.projectTypeList[0], 0) // 默认查询
        })
      }
    },
    // 扫码枪监听
    scannerGunListening(callBack, obj) {
      // 扫码枪
      let code = '' // 累积按键字符（用于扫码枪场景）
      let lastTime, nextTime // 上一次按键时间、本次按键时间（用于计算间隔）
      let lastCode, nextCode // 上一次键码、本次键码（用于兼容浏览器和识别回车）
      let _this = this // 保存 Vue 组件实例引用
      let scannerTimer = null // 重置扫码状态的定时器

      document.onkeypress = function (e) {
        // 判断按键是否为数字(0-9)
        let isNumber = JSON.stringify(Number(e.key)) !== 'null'
        // 兼容性适配
        if (window.event) { // IE
          nextCode = e.keyCode
        } else if (e.which) { // Netscape/Firefox/Opera
          nextCode = e.which
        }

        // 13 代表 回车
        if (nextCode === 13) {
          if (code.length >= 3) {
            // 阻止回车可能触发的默认行为（如表单提交）
            if (e.preventDefault) {
              e.preventDefault() // 阻止浏览器执行该事件的默认行为
              e.stopPropagation() // 阻止冒泡
            }
            // 强制关闭搜索框（如果开着的话）
            if (_this.searchInputBoxShow) {
              _this.queryItem = ''; // 清空输入框内容
              _this.searchInputBoxShow = false // 关闭搜索框
              _this.openProjectQuery(false)

              // 恢复默认搜索
              _this.projectTypeList[0].dictName === '全部' && _this.projectTypeList.splice(0, 1)
              _this.projectType = 0
              _this.switchItems(_this.projectTypeList[0], 0) // 默认查询
            }

            _this.isScannerEnter = true;    // 标记本次回车来自扫码枪

            // 当前正在处理扫码枪触发的挂单操作，暂时不要弹出项目搜索框
            _this.isOpenTime = true // 标记扫码枪操作开始

            // 截取末尾三位数
            const shortCode = code.length >= 3 ? code.slice(-3) : code
            callBack(shortCode, obj) // 执行挂单

            code = ''
            lastCode = ''
            lastTime = ''
            setTimeout(() => {
              _this.isOpenTime = false // ← 200ms 后重置标志
              _this.isScannerEnter = false;   // 新增：200ms 后重置
            }, 200)
            _this.isScannerInput = false
            clearTimeout(scannerTimer)
          }
          return
        }

        nextTime = new Date().getTime()

        // 判断是否为扫码枪快速输入(两次按键间隔 < 30ms 且为数字)
        if (lastTime && nextTime - lastTime < 30 && isNumber) {
          // 阻止字符进入当前焦点输入框
          if (e.preventDefault) {
            e.preventDefault()
            e.stopPropagation()
          }
          // 强制关闭搜索框（如果开着的话）
          if (_this.searchInputBoxShow) {
            _this.queryItem = ''; // 清空输入框内容
            _this.searchInputBoxShow = false // 关闭搜索框
            _this.openProjectQuery(false)

            // 恢复默认搜索
            _this.projectTypeList[0].dictName === '全部' && _this.projectTypeList.splice(0, 1)
            _this.projectType = 0
            _this.switchItems(_this.projectTypeList[0], 0) // 默认查询
          }
          _this.isScannerInput = true
          clearTimeout(scannerTimer)
          scannerTimer = setTimeout(() => {
            _this.isScannerInput = false
          }, 500)
        } else {
          // 非快速连续输入，可能是手动打字
          _this.isScannerInput = false
        }

        if (!lastTime && !lastCode) {
          code += e.key
          // 首次输入 开启页面搜索功能
          // isNumber && _this.drawerType === 0 && _this.openProjectQuery(true, e.key)
          if (isNumber && _this.drawerType === 0 && !_this.isScannerInput) {
            _this.openProjectQuery(true, e.key)
          }
        }

        if (lastCode && lastTime && nextTime - lastTime > 25) { // 当扫码前有keypress事件时,防止首字缺失
          code = e.key
          console.log('手动', isNumber, this.drawerType)
          // 手动输入进行页面项目查询
          isNumber && _this.drawerType === 0 && _this.openProjectQuery(true, e.key)
        } else if (lastCode && lastTime) {
          code += e.key
        }
        lastCode = nextCode
        lastTime = nextTime
      }
    },
    // 监听2次回车结算
    monitorCarriageReturnPayment(callBack) {
      let carriageReturnMonitor = [0, 0] // 监听回车时间
      let carriageReturnNumber = 0 // 回车键次数
      let time = null
      let _this = this;   // 保存组件实例
      document.onkeyup = async function ($event) {
        if ($event.key !== 'Enter') return
        // 扫码枪触发的回车不参与计数
        if (_this.isScannerEnter) return
        // 防止按下第一次后 不进行第二次的按下 导出出现顺序错误问题 需要设置一个计时器在规定的时间内完成 如果没完成恢复默认状态
        time = setTimeout(() => {
          carriageReturnMonitor = [0, 0] // 监听回车时间
          carriageReturnNumber = 0 // 回车键次数
        }, 800)
        // 获取当前时间戳
        let currentTime = new Date().getTime()
        // 记录第一次按下回车时间
        carriageReturnMonitor[carriageReturnNumber++] = currentTime // 存储时间戳
        // 开始计算时间差
        if (carriageReturnMonitor[1]) {
          console.log(carriageReturnMonitor[0], carriageReturnMonitor[1], '开始计算时间插', carriageReturnMonitor[1] - carriageReturnMonitor[0])
          // 是否符合2次回车结算触发要求
          let whetherItMeets = carriageReturnMonitor[1] - carriageReturnMonitor[0]
          // 如果小于800毫秒则视为连续输入
          if (whetherItMeets <= 800) {
            clearTimeout(time) // 清除防止出现顺序错误的计时器
            let state = await callBack() // 调用回调函数
            if (state) document.onkeyup = null // 关闭监听
          }
          carriageReturnMonitor = [0, 0] // 监听回车时间
          carriageReturnNumber = 0 // 回车键次数
        }
      }
    }
  }
}

export default mixins



// WEBPACK FOOTER //
// ./src/views/paperless/mixins/paperlessPublic.js